import {
  CardBaseHeader,
  FlexContainer,
  Label,
  Map as MapUi,
  StatusBase,
} from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { MapProps } from './model';
import { MapCard, MapContainer } from './Styles';

export const Map = ({ data }: MapProps) => {
  const { t } = useTranslation();

  return (
    <MapCard>
      <CardBaseHeader small>
        <FlexContainer justifyContent="center" flex="1">
          <Label fontSize="14" semibold>
            {t('Nationality vs geolocalization')}
          </Label>
        </FlexContainer>
      </CardBaseHeader>
      <MapContainer
        flexDirection="row"
        justifyContent="space-around"
        alignItems="center"
        flex="1"
      >
        <FlexContainer>
          <MapUi />
        </FlexContainer>
        <FlexContainer flexDirection="column" rowGap="0.8">
          {data?.map((value, index) => (
            <FlexContainer
              flexDirection="row"
              columnGap="4"
              key={index}
              justifyContent="space-between"
              alignItems="center"
            >
              <StatusBase color={value.color} />
              <Label fontSize="12" semibold>
                {t(value.title)}
              </Label>
              <Label fontSize="10">
                {t(value.description)} {value.count}
              </Label>
            </FlexContainer>
          ))}
        </FlexContainer>
      </MapContainer>
    </MapCard>
  );
};
